import { AxisChartAPI } from '../axis-chart/axis-chart-api.js';
class ComposedChartAPI extends AxisChartAPI {
    getAreas() {
        return this.state.areas;
    }
    setAreas(areas) {
        this.setState({ areas });
    }
    getActiveDot() {
        return this.state.activeDot;
    }
    setActiveDot(activeDot) {
        this.setState({ activeDot });
    }
    getBarCategoryGap() {
        return this.state.barCategoryGap;
    }
    setBarCategoryGap(barCategoryGap) {
        this.setState({ barCategoryGap });
    }
    getBarGap() {
        return this.state.barGap;
    }
    setBarGap(barGap) {
        this.setState({ barGap });
    }
    getBars() {
        return this.state.bars;
    }
    setBars(bars) {
        this.setState({ bars });
    }
    getDot() {
        return this.state.dot;
    }
    setDot(dot) {
        this.setState({ dot });
    }
    getLines() {
        return this.state.lines;
    }
    setLines(lines) {
        this.setState({ lines });
    }
}
export { ComposedChartAPI, };
//# sourceMappingURL=composed-chart-api.js.map